// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__J_osw","disabled":"FileBtn_disabled__gcSPa","warn":"FileBtn_warn__11YU1","fade":"FileBtn_fade__Q-v4W"};